import React, { FC, useEffect, useState } from 'react'
import { useAlert } from 'react-alert'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { updateMailDelivery } from '../../../states/containers/setting/systemSlice'
import { deleteSlackOauth } from '../../../states/apis/slack_oauth'
import { RootState } from '../../../states/containers/store'

const SlackInfo: FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const alert = useAlert()

  const {
    system,
    commonPart,
    login,
  } = useSelector((state: RootState) => (state))

  const [workStyleAlert, setWorkStyleAlert] = useState<boolean>(true)
  const [notStarted, setNotStarted] = useState<boolean>(true)
  const [newReport, setNewReport] = useState<boolean>(true)
  const [approval, setApproval] = useState<boolean>(true)

  const [isDisassociation, setIsDisassociation] = useState<boolean>(true)

  useEffect(() => {
    setWorkStyleAlert(false)
    setNotStarted(!!system.mail_delivery?.slack_not_started)
    setNewReport(!!system.mail_delivery?.slack_new_report)
  }, [system.mail_delivery])

  useEffect(() => {
    if (!system.custom_alert_list?.length) return
    setIsDisassociation(
      !system.custom_alert_list.filter(
        (custom_alert) => (custom_alert.member_id === commonPart.current_member_id && custom_alert.notice_type === "slack"),
      ).length,
    )
  }, [system.custom_alert_list])

  const handleSlackSubmit = () => {
    if (!system.mail_delivery) return
    dispatch(
      updateMailDelivery(
        {
          ...system.mail_delivery,
          slack_integration: true,
          slack_not_started: notStarted,
          slack_work_style_alert: workStyleAlert,
          slack_new_report: newReport,
          slack_approval: login.function_enabled_state?.task_management_approval ? approval : true,
        },
        () => {
          alert.success(t('form.alert.updated'))
        },
      ),
    )
  }

  const handleSlackDisassociation = () => {
    if (!system.mail_delivery) return
    // eslint-disable-next-line no-alert
    if (window.confirm(t('setting.system.slack_delivery.confirm.text'))) {
      dispatch(
        updateMailDelivery(
          {
            ...system.mail_delivery,
            slack_integration: false,
          },
          () => {
            alert.success(t('form.alert.updated'))
          },
        ),
      )
      dispatch(deleteSlackOauth())
    }
  }

  return (
    <>
      {
        system.mail_delivery?.slack_integration ? (
          <>
            <div className="content check_item">
              <input
                type="checkbox"
                id="slackNotStartedDisplay"
                onChange={(event) => setNotStarted(event.target.checked)}
                checked={notStarted}
              />
              &nbsp;
              <label htmlFor="slackNotStartedDisplay">{t(`setting.system.slack_delivery.not_started_enabled`)}</label>
            </div>
            <div className="content check_item">
              <input
                type="checkbox"
                id="slackNewReportDisplay"
                onChange={(event) => setNewReport(event.target.checked)}
                checked={newReport}
              />
              &nbsp;
              <label htmlFor="slackNewReportDisplay">{t(`setting.system.slack_delivery.new_report_enabled`)}</label>
            </div>
            {
              login.function_enabled_state?.task_management_approval && (
                <div className="content check_item">
                  <input
                    type="checkbox"
                    id="slackApprovalDisplay"
                    onChange={(event) => setApproval(event.target.checked)}
                    checked={approval}
                  />
                  &nbsp;
                  {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                  <label htmlFor="slackApprovalDisplay">申請・承認お知らせSlack通知を受信する</label>
                </div>
              )
            }
            <div className="content check_item">
              <button
                type="button"
                className="mt-4 button"
                onClick={handleSlackSubmit}
              >
                {t('setting.system.slack_delivery.submit')}
              </button>
            </div>
            <div className="content check_item">
              <button
                type="button"
                className="mt-4 button delete"
                onClick={handleSlackDisassociation}
              >
                {t('setting.system.slack_delivery.disassociation')}
              </button>
              {
                !isDisassociation && (
                  <div className="description red_mini">
                    <p>
                      {t('setting.system.slack_delivery.message1')}
                    </p>
                  </div>
                )
              }
            </div>
          </>
        ) : (
          <a
            // eslint-disable-next-line max-len
            href={`https://slack.com/oauth/v2/authorize?client_id=859391699442.2670538394279&scope=channels:join,chat:write,groups:read&user_scope=channels:read,channels:write,groups:read,groups:write,im:read,im:write,mpim:read,mpim:write,chat:write&redirect_uri=${process.env.APP_URL}/slackoauth`}
          >
            <img
              alt="Add to Slack"
              height="40"
              width="139"
              src="https://platform.slack-edge.com/img/add_to_slack.png"
              srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x"
            />
          </a>
        )
      }
    </>
  )
}

export default SlackInfo
